import { environment } from '@environments/environment';

export const houseMatchSurveyUri = `${environment.houseMatchUri}/:lang/:slug/:review`;
export const writeReviewLocalizedRouteLabel = 'HOUSE_MATCH.LOCALIZED_ROUTES.write-review';
